export function getFetchPolicy(forceRefetch: boolean) {
  return forceRefetch ? "network-only" : "cache-first"
}
